import GerenciadorNFeService from "@/services/GerenciadorNFeService";

export const gerenciadorNFe = {
  namespaced: true,
  state: {
    gerenciadorNFe: {},
  },
  actions: {
    consultarStatusServico({ commit }, payload) {
      return GerenciadorNFeService.ConsultarStatusServico(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    consultarStatusNota({ commit }, payload) {
      return GerenciadorNFeService.ConsultarStatusNota(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    transmitirNota({ commit }, payload) {
      return GerenciadorNFeService.TransmitirNota(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    cancelarNota({ commit }, payload) {
      return GerenciadorNFeService.CancelarNota(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    inutilizarNFe({ commit }, payload) {
      return GerenciadorNFeService.InutilizarNFe(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    transmitirCCeNFe({ commit }, payload) {
      return GerenciadorNFeService.TransmitirCCeNFe(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    imprimirNFe({ commit }, payload) {
      return GerenciadorNFeService.ImprimirNFe(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    previsualizarNFe({ commit }, payload) {
      return GerenciadorNFeService.PrevisualizarNFe(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    imprimirCCe({ commit }, payload) {
      return GerenciadorNFeService.ImprimirCCe(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    corrigirDuplicidadeNFe({ commit }, payload) {
      return GerenciadorNFeService.CorrigirDuplicidadeNFe(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },

    downloadXMLNFe({ commit }, payload) {
      return GerenciadorNFeService.DownloadXMLNFe(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },

    getXMLDownload({ commit }, payload) {
      return GerenciadorNFeService.GetXMLDownload(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },

    DownloadDiretorio({ commit }, payload) {
      return GerenciadorNFeService.DownloadDiretorio(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {},
};

export default gerenciadorNFe;
